module.exports = __webpack_public_path__ + "img/psd.e2986eef.svg";